/* Fichier ./src/index.js */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './fonts.css'; // Ajoutons le CSS
import App from './App';
import reportWebVitals from './reportWebVitals';
import indexedDBService from './services/indexedDB';

// Initialisation de la base de données IndexedDB
indexedDBService.initializeDB();

console.log('Index.js est chargé');

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM entièrement chargé');
  console.log('Élément root :', document.getElementById('root'));
});

// src/index.js
window.addEventListener('error', (event) => {
  console.error('Erreur globale attrapée:', event.error);
});



// Vous pouvez aussi ajouter un ErrorBoundary autour de votre application
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Erreur capturée par ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, color: 'red' }}>
          <h1>Une erreur s'est produite</h1>
          <p>{this.state.error?.toString()}</p>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

/*
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Enregistrement du Service Worker pour les notifications push
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Utiliser une URL relative à l'origine pour éviter les problèmes de portée
    navigator.serviceWorker.register('/brightbar/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
        // Afficher l'erreur de manière plus détaillée
        if (error.name === 'SecurityError') {
          console.error('Le Service Worker a été bloqué pour des raisons de sécurité');
        } else if (error.name === 'TypeError') {
          console.error('Problème de type MIME ou fichier non trouvé');
        }
      });
  });
}